// Helpers for the manufacturer configuration catalogue (CWA-91). Kept out of
// the components so the rules the backend actually applies can be unit tested.

import { VendorConfig } from "../types/onboarding";

export const GENERIC_VENDOR_ID = "GENERIC";

/**
 * Which catalogue entry a prospect's configuration email will actually use.
 * Mirrors the backend's lookup: match the manufacturer name case-insensitively,
 * otherwise fall back to the generic entry. Returns null when neither exists,
 * so callers can say "none" instead of implying a wrong one.
 */
export const vendorForManufacturer = (
  configs: VendorConfig[],
  manufacturer: string | null | undefined
): VendorConfig | null => {
  if (!configs?.length) return null;
  const key = (manufacturer ?? "").trim().toUpperCase();
  return (
    configs.find((c) => c.vendor_id?.toUpperCase() === key) ??
    configs.find((c) => c.vendor_id?.toUpperCase() === GENERIC_VENDOR_ID) ??
    null
  );
};

/** True when the entry says a file is required but none is attached. */
export const isVendorConfigIncomplete = (config: VendorConfig): boolean =>
  (config.requires_pdf_guide && !config.pdf_guide_s3_key) ||
  (config.requires_certificate && !config.certificate_s3_key);

/**
 * The file name to show for an attached asset. The API stores full storage keys
 * ("vendors/ALFEN/certificate.fwi"); showing those would leak internals, so
 * only the file name is ever displayed.
 */
export const assetFileName = (storageKey: string | null): string | null => {
  if (!storageKey) return null;
  const parts = storageKey.split("/").filter(Boolean);
  return parts.length ? parts[parts.length - 1] : null;
};
